import { useHistory, useLocation } from 'react-router-dom';
import { useCallback, useMemo } from 'react';

export const useURLFilters = () => {
  const location = useLocation();
  const history = useHistory();

  const filters = useMemo(() => {
    const params = new URLSearchParams(location.search);
    const result = {};
    
    params.forEach((value, key) => {
      // Handle numeric values
      if (!isNaN(Number(value)) && value !== '') {
        result[key] = Number(value);
      } else {
        result[key] = value;
      }
    });
    
    return result;
  }, [location.search]);

  const updateFilters = useCallback((newFilters) => {
    const params = new URLSearchParams(location.search);
    
    Object.entries(newFilters).forEach(([key, value]) => {
      if (value === undefined || value === null || value === '') {
        params.delete(key);
      } else {
        params.set(key, String(value));
      }
    });
    
    history.push({ search: params.toString() });
  }, [location.search, history]);

  const clearFilters = useCallback(() => {
    history.push({ search: '' });
  }, [history]);

  return { filters, updateFilters, clearFilters };
};

export const buildQueryString = (params) => {
  const searchParams = new URLSearchParams();
  
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      searchParams.set(key, String(value));
    }
  });
  
  return searchParams.toString();
};

export const parseQueryString = (search) => {
  const params = new URLSearchParams(search);
  const result = {};
  
  params.forEach((value, key) => {
    if (!isNaN(Number(value)) && value !== '') {
      result[key] = Number(value);
    } else {
      result[key] = value;
    }
  });
  
  return result;
};